import { queryKeys } from '@/tanstack-query/query-keys';
import { DocData } from '@/types/legal';
import { QueryObserverResult, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getLegalDocsData } from './get-legal-docs-data';

/**
 * Хук для получения списка документов с возможностью типизации возвращаемых данных через селектор.
 * @param selector Функция-селектор для преобразования данных
 * @returns useQuery результат с типом, соответствующим селектору или DocData[] по умолчанию
 */
export function useDocsList<T = DocData[]>(
	selector?: (data: DocData[]) => T,
): QueryObserverResult<T, unknown> {
	const params: UseQueryOptions<DocData[], unknown, T> = {
		queryKey: queryKeys.docList,
		queryFn: getLegalDocsData,
	};

	if (selector) {
		params.select = selector;
	}

	return useQuery(params);
}
